import { Component, inject, ViewEncapsulation } from '@angular/core';
import { AccountFormComponent } from '@components/account-form/account-form.component';
import { Account, Accounts } from '@models/account';
import { OverlayService } from '@services/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lv-account-index',
  templateUrl: './account-index.component.html',
  styleUrls: ['./account-index.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule]
})
export class AccountIndexComponent {
  private accountService = inject(Accounts);
  private overlayService = inject(OverlayService);

  accounts = this.accountService.$search();

  edit(account: Account) {
    this.overlayService.open(AccountFormComponent, { account: account });
  }

  newAccount() {
    this.overlayService.open(AccountFormComponent, { account: this.accounts.$build() });
  }
}
